import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Input, InputField } from "@/components/ui/input";
import React, { useEffect, useState } from 'react'
import { ModalWrapper } from "./ModalWrapper";

import { useSelector } from "react-redux";

import i18n from "i18n-js";

export const ContactRequest = (modal) => {
  const isWaiting = modal.option?.request?.isWaiting ?? false;
  const isAcknowledged = modal.option?.request?.isAcknowledged ?? false;
  const hasIssues = modal.option?.request?.issues ?? {};

  const user = useSelector((state) => state.user);

  let [inputContactMail, onInputContactMail] = useState('');

  if (isAcknowledged) {
    modal.onClose();
  }

  useEffect(() => {
    // ? clear inputs
    if (modal.opened === undefined) {
      onInputContactMail('');
    }
  }, [modal.opened]);


  const onBack = () => {
    modal.onClose();
  }

  const onSubmit = () => {
    submitInputs({
      contact: { mail: inputContactMail }
    });
  }

  const submitInputs = ({ contact }) => {
    const issues = {}, request = {
      isWaiting: false,
      isAcknowledged: false,
      issues: null
    };

    // ? values
    const contact_mail = contact.mail.trim().toLowerCase()

    // ? validation
    if (contact_mail == user.mail) {
      issues['contact.mail'] = 'err:isOwnEmail';
    }
    if (!contact_mail.match(/^\S+@\S+\.\S+$/)) {
      issues['contact.mail'] = 'err:isNotAnEmail';
    }

    if (Object.keys(issues).length) {
      request.issues = issues;

      modal.onUpdate({ request });
      return;
    };

    // ? request
    request.isWaiting = true;

    modal.onUpdate({ request });
    modal.onRequest('REQUEST_CONTACT_INLINE', '/contact/request', {
      mail: contact_mail,
    }).then((data) => {
      // ---
      console.debug('[Modal]', 'onRequest.then', !!data.result, data?.result)
      // ---

      if (data.result) {
        modal.onUpdate({
          request: {
            isAcknowledged: true,  // signal can close
            isWaiting: true, // keep locked
            issues: null,
          }
        });
      } else {
        modal.onUpdate({
          request: {
            isAcknowledged: false,  // signal can close
            isWaiting: false,
            issues: {
              'request-failed': '*' // User ID unknown
            },
          }
        });
      }

    })
  }

  return (
    <ModalWrapper
      onClose={modal.onClose}
      onBack={onBack}
      onSubmit={onSubmit}

      isVisible={modal.isVisible}
      isWaiting={isWaiting}

      title={i18n.t('addContact.title')}
      buttonBack={{text: i18n.t('addContact.cancel')}}
      buttonSubmit={{text: i18n.t('addContact.send')}}
    >
      <Text className="text-md text-secondary-600">{i18n.t('addContact.text')}</Text>
      <VStack>
        <Input
          variant="outline" size="md"
          isDisabled={isWaiting || !modal.isVisible}
          isInvalid={'contact.mail' in hasIssues}
          isReadOnly={false}
        >
          <InputField
            defaultValue={inputContactMail}
            onChangeText={onInputContactMail}
            placeholder={i18n.t('addContact.emailAddress')}
          />
        </Input>
        {'contact.mail' in hasIssues && (
          <Text className="mt-2 text-xs text-error-600">{i18n.t('addContact.text')}</Text>
        )}
      </VStack>
      <VStack>
        {'request-failed' in hasIssues && (
          <Text className="mt-2 text-xs text-error-600">{i18n.t('addContact.requestFailCheckInputs', { user: inputContactMail })}</Text>
        )}
      </VStack>
    </ModalWrapper>
  );
}
